import styled from "styled-components";

export const TopSectionWrap = styled.div``;

export const StyledPageWrapper = styled.div`
  overflow: hidden;
  position: relative;
`;
